import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/onboarding/shrug-emoji.png'


const _hoisted_1 = { class: "onboarding-books__cover-section" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "onboarding-books__controls-wrapper" }
const _hoisted_5 = { class: "onboarding-books__controls" }

import { computed, onMounted } from 'vue'

import type { BooksChoice, BooksPage } from '@/models/onboarding.types'
import { getImage, QuestionnaireView } from '@/models/onboarding'

import Layout from './Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BooksPick',
  props: {
    view: {}
  },
  emits: ["done"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as BooksPage
})

const currentChoices = computed(() => {
  return props.view.currentChoice as BooksChoice
})

const emit = __emit

const currentBook = computed(() => {
  return page.value.content[props.view.currentSubpageIndex]
})

const currentBookCover = computed(() => {
  return getImage(`${currentBook.value}.png`)
})

function nextBook(score: number): void {
  props.view.setCurrentChoice([
    ...currentChoices.value,
    { id: currentBook.value, score },
  ])

  const nextBookExists = props.view.nextSubpage()

  if (!nextBookExists) {
    emit('done')
  }
}

onMounted(() => {
  props.view.setCurrentChoice([])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-books",
    title: page.value.title,
    subtitle: page.value.subtitle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: currentBook.value,
              class: "onboarding-books__cover-wrapper"
            }, [
              _createElementVNode("img", {
                src: currentBookCover.value,
                alt: currentBook.value,
                width: "223",
                height: "298",
                class: "onboarding-books__cover"
              }, null, 8, _hoisted_2),
              _createElementVNode("img", {
                src: currentBookCover.value,
                alt: currentBook.value,
                class: "onboarding-books__cover onboarding-books__cover--background"
              }, null, 8, _hoisted_3)
            ]))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "onboarding-books__button onboarding-books__button--negative",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (nextBook(-1)), ["prevent"]))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "iconfont idislike" }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "onboarding-books__button onboarding-books__button--neutral",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (nextBook(0)), ["prevent"]))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "onboarding-books__button onboarding-books__button--positive",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (nextBook(1)), ["prevent"]))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "iconfont ilike" }, null, -1)
          ]))])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "onboarding-books__controls-labels" }, [
          _createElementVNode("p", { class: "onboarding-books__controls-label" }, "Not at all"),
          _createElementVNode("p", { class: "onboarding-books__controls-label" }, "Very interested")
        ], -1))
      ])
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})